module.exports = __webpack_public_path__ + "static/media/White 1008.6515860c.jpg";